import './styles.index.js';
function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('Root/views', true, /\.js$/));


